import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {Box, Button, CheckBox, DateInput, Form, FormField, Heading, Text, TextInput} from 'grommet';
import {TextInputField, validators} from 'grommet-controls';
import { FormView, FormViewHide } from 'grommet-icons';
import {storeRefreshToken, storeToken, storeUserId} from '../utils/token'
import jwt_decode from "jwt-decode";
import {toast, ToastContainer} from "react-toastify";
const BASE_URL = 'baseurl';
const Register = () => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [birthday, setBirthday] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState(false);
    const [showPassword, setShowPassword] = useState(false);


    const onChangeBirthday = (event) => {
        const nextValue = event.value;
        //let date = new Date(nextValue).toLocaleDateString('it-IT')
        setBirthday(nextValue);
    };

    const onChangePrivacyPolicyAccepted = (event) => {
        const nextValue = event.target.checked;

        //let date = new Date(nextValue).toLocaleDateString('it-IT')
        setPrivacyPolicyAccepted(nextValue);

    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            setErrorMessage('Le passwords non corrispondono');
            return;
        }
        let birthdayDate = new Date(birthday).toLocaleDateString('it-IT');
        try {
            axios.post(process.env.REACT_APP_BASE_API_URL + 'register', {
                email,
                password,
                name,
                surname,
                birthdayDate,
                phone,
                privacyPolicyAccepted,
            })
                .then(response => {
                    console.log(response);
                    //window.location.href = '/dashboard';
                    axios.post(process.env.REACT_APP_BASE_API_URL + 'auth', {
                        email,
                        password,
                    })
                        .then(response => {
                            storeToken(response.data.token);
                            storeRefreshToken(response.data.refreshToken);
                            let decodedToken = jwt_decode(response.data.token);
                            storeUserId(jwt_decode(response.data.token).userId);
                            window.location.href = '/webapp/dashboard';
                        })
                        .catch(error => {
                            console.error(error);
                        });

                })
                .catch(error => {
                    toast.error("Ops! Qualcosa è andato storto 😞", {
                        position: "bottom-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                });

        } catch (error) {
            console.error(error);
            setErrorMessage('Errore. Prova ancora');
        }
    };

    return (
        <Box align="center" pad="medium">
            <Heading level="1">Registrati</Heading>
            {errorMessage && <Text color="status-critical">{errorMessage}</Text>}
            <Form onSubmit={handleSubmit}>
                <FormField name="email" label="Email" required>
                    <TextInput
                        id="email"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                    />
                </FormField>
                <FormField name="name" label="Nome" required>
                    <TextInput
                        type="string"
                        value={name}
                        name="name"
                        onChange={(event) => setName(event.target.value)}
                    />
                </FormField>
                <FormField name="surname" label="Cognome" required>
                    <TextInput
                        type="string"
                        value={surname}
                        name="surname"
                        onChange={(event) => setSurname(event.target.value)}
                    />
                </FormField>
                <FormField name="birthday" label="Data di Nascita">
                    <DateInput
                        id="birthday"
                        calendarProps={{ locale : "it" }}
                        dropProps={{ align: { top: "bottom", left: "left" } }}
                        inline={false}
                        name="birthday"
                        format="dd/mm/yyyy"
                        value={birthday}
                        onChange={onChangeBirthday}
                    />
                </FormField>
                <FormField
                    name="phone"
                    label="Telefono"
                    validate={[
                        { regexp: /^[0-9]/i },
                        (phone) => {
                            if (phone && phone.length < 9) return 'inserire numero valido';
                            return undefined;
                        },
                    ]}
                >
                    <TextInput
                        label="phone"
                        name="phone"
                        value={phone}
                        onChange={(event) => setPhone(event.target.value)}
                    />
                </FormField>
                <FormField
                    name="password"
                    label="Password"
                    required
                    validate={[
                        {
                            regexp: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/,
                            message: 'La password deve essere lunga almeno 8 caratteri e includere una combinazione di lettere e numeri.'
                        },
                        // Add more validation rules if needed
                    ]}
                >
                    <Box
                        direction="row"
                        align="center"
                        //border={{ side: 'bottom', color: 'brand' }} // You can customize the border color and other properties
                        pad={{bottom: 'small'}} // Add padding if necessary
                    >
                        <TextInput
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            plain // This removes the TextInput's border

                        />
                        <Button
                            icon={showPassword ? <FormView/> : <FormViewHide/>}
                            onClick={() => setShowPassword(!showPassword)}
                        />
                    </Box>
                    <Text size="small" margin={{top: 'xsmall'}}>
                        La password deve essere lunga almeno 8 caratteri e includere una combinazione di lettere e
                        numeri.
                    </Text>
                </FormField>
                <FormField
                    name="confirmPassword"
                    label="Confirm Password"
                    required
                    validate={[
                        {
                            regexp: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/,
                            message: 'La password deve essere lunga almeno 8 caratteri e includere una combinazione di lettere e numeri.'
                        },
                        // Add more validation rules if needed
                    ]}
                >
                    <Box
                        direction="row"
                        align="center"
                        //border={{ side: 'bottom', color: 'brand' }} // You can customize the border color and other properties
                        pad={{bottom: 'small'}} // Add padding if necessary
                    >
                        <TextInput
                            type={showPassword ? 'text' : 'password'}
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                            plain // This removes the TextInput's border

                        />
                        <Button
                            icon={showPassword ? <FormView/> : <FormViewHide/>}
                            onClick={() => setShowPassword(!showPassword)}
                        />
                    </Box>
                    <Text size="small" margin={{top: 'xsmall'}}>
                        La password deve essere lunga almeno 8 caratteri e includere una combinazione di lettere e
                        numeri.
                    </Text>
                </FormField>
                <FormField name="privacyPolicyAccepted" label="Accetta termini e condizioni" required={true}>
                    <CheckBox
                        name="privacyPolicyAccepted"
                        checked={privacyPolicyAccepted}
                        onChange={onChangePrivacyPolicyAccepted}
                    />
                </FormField>
                <Button type="submit" label="Registrati" primary />
            </Form>
            <Text>
                Hai già un account? <Link to="/">Log in</Link>
            </Text>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </Box>
    );
};

export default Register;
